import createRef from "./createRef";
function createElementRef(props) {
    return createRef(props);
}
export default createElementRef;
